import { EnvironmentInjector, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { OnboardingService } from 'src/app/services/onboarding.service';
import { AuthService } from '../auth.service';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';
import { CookieService } from 'ngx-cookie-service';
import { UtmInfo } from '../utm-tracker.service';

@Injectable({
    providedIn: 'root'
})
export class OnboardingGuardService {

    constructor(private authService: AuthService, private onboardingService: OnboardingService, private _router: Router, @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector, private cookieService: CookieService) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.authService.isLoggedIn().subscribe((isLoggedIn: boolean) => {
            if (!isLoggedIn) {
                return true;
            } else {
                var userInfo = this.authService.getCurrentUser();//.subscribe( x=> userInfo = x);
                if (!userInfo || userInfo.profile[this.authService.ACCOUNT_OWNER_ID_CLAIM] != null) {
                    return true;
                }
                // # Before creating the user, check if there is campaign info
                // and pass it to the registration process
                const utmDataRaw = this.cookieService.get('utm_info');
                const utmData: UtmInfo | null = utmDataRaw ? JSON.parse(utmDataRaw) : null;
                this.cookieService.delete('utm_info', '/');
                
                //Create user
                this.onboardingService.createAccountOwner(userInfo.profile, undefined, utmData)
                .pipe(
                    catchError(() => {
                        // # Recreate the cookie with the same campaign info (if previously had value),
                        // if the API call fails during anonymous registration process
                        if (utmData) {
                            this.cookieService.set('utm_info', JSON.stringify(utmData), 14, '/');
                        }
                        return of(null);
                    })
                ).subscribe();
                var intent = userInfo.profile[this.authService.INTENT_CLAIM];
                // # Upon account registration, the identity service is responsible for passing down the language,
                // to ensure navigation to the correct localized portal welcome link.
                var locale = userInfo.profile.locale ?? 'el';
                if (intent === this.authService.INTENT_SELLER) {
                    this._router.navigate([`${locale}/welcome/seller`], { queryParamsHandling: 'preserve' })
                    return false;
                }
                if (intent === this.authService.INTENT_BUYER) {
                    this._router.navigate([`${locale}/welcome/buyer`], { queryParamsHandling: 'preserve' })
                    return false;
                }
                else {
                    this._router.navigate([`${locale}/welcome/default`], { queryParamsHandling: 'preserve' })
                    return true;
                }
            }
        });
        return of(true);
    }
}


